import { getBackendUrl } from './backendUrl'

export const ROBOLABX_LOGIN_CLIENT_REGISTRATION_ID = 'robolabx-bff-client'

export const STUDENT_MASCOTS = [
  { id: 'lion', emoji: '🦁', label: 'Lion' },
  { id: 'panda', emoji: '🐼', label: 'Panda' },
  { id: 'tiger', emoji: '🐯', label: 'Tiger' },
  { id: 'cat', emoji: '🐱', label: 'Cat' },
  { id: 'dog', emoji: '🐶', label: 'Dog' },
  { id: 'rabbit', emoji: '🐰', label: 'Rabbit' },
  { id: 'fox', emoji: '🦊', label: 'Fox' },
  { id: 'bear', emoji: '🐻', label: 'Bear' },
  { id: 'koala', emoji: '🐨', label: 'Koala' },
  { id: 'frog', emoji: '🐸', label: 'Frog' },
  { id: 'monkey', emoji: '🐵', label: 'Monkey' },
  { id: 'penguin', emoji: '🐧', label: 'Penguin' },
  { id: 'cow', emoji: '🐮', label: 'Cow' },
  { id: 'pig', emoji: '🐷', label: 'Pig' },
  { id: 'chick', emoji: '🐥', label: 'Chick' },
  { id: 'turtle', emoji: '🐢', label: 'Turtle' },
] as const

export const STUDENT_SECRET_EMOJIS = [
  { id: 'apple', emoji: '🍎', label: 'Apple' },
  { id: 'star', emoji: '⭐', label: 'Star' },
  { id: 'car', emoji: '🚗', label: 'Car' },
  { id: 'rainbow', emoji: '🌈', label: 'Rainbow' },
  { id: 'music', emoji: '🎵', label: 'Music' },
  { id: 'moon', emoji: '🌙', label: 'Moon' },
  { id: 'basketball', emoji: '🏀', label: 'Basketball' },
  { id: 'paint', emoji: '🎨', label: 'Paint' },
  { id: 'dog', emoji: '🐶', label: 'Dog' },
  { id: 'cake', emoji: '🎂', label: 'Cake' },
  { id: 'rocket', emoji: '🚀', label: 'Rocket' },
  { id: 'book', emoji: '📘', label: 'Book' },
  { id: 'flower', emoji: '🌸', label: 'Flower' },
  { id: 'pizza', emoji: '🍕', label: 'Pizza' },
  { id: 'cookie', emoji: '🍪', label: 'Cookie' },
  { id: 'gift', emoji: '🎁', label: 'Gift' },
] as const

export type StudentMascot = (typeof STUDENT_MASCOTS)[number]
export type StudentSecretEmoji = (typeof STUDENT_SECRET_EMOJIS)[number]

export function normalizeStudentFullName(value: string): string {
  return value.trim().replace(/\s+/g, ' ')
}

export function buildStudentUsername(mascotId: string, fullName: string): string {
  return `${mascotId}|${normalizeStudentFullName(fullName)}`
}

export function buildStudentPassword(secretIds: string[]): string {
  return secretIds.join('|')
}

export function getRoboLabLoginUrl(): string {
  return `${getBackendUrl()}/api/oauth2/login?client_registration_id=${ROBOLABX_LOGIN_CLIENT_REGISTRATION_ID}`
}

export async function submitRoboLabLogin(payload: { username: string; password: string }): Promise<void> {
  const response = await fetch(getRoboLabLoginUrl(), {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })

  if (response.ok) return
  throw new Error('Unable to sign in. Please check your details and try again.')
}
